//This will be removed once all exchanges transition to the new NiceCXOneChat

import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

const ChatLink = props => {
    const {
        details: {
            name,
            className,
            linkClassName,
            text,
            path,
        },
        environment: {
            impersonation,
            impersonationDetails,
            links,
            flags: {
                isLegacyChatEnabled,
                isWebChatEnabled,
                isWebChatEnglishEnabled,
                isWebChatSpanishEnabled
            }
        },
        index,
        user,
        language,
    } = props;

    if (!isLegacyChatEnabled) return null;

    //based on iex config
    const getConfigLanguage = () => {
        if(isWebChatEnabled && isWebChatEnglishEnabled && isWebChatSpanishEnabled) {
            return language;
        } else if(isWebChatEnabled && isWebChatEnglishEnabled) {
            return 'en';
        } else if(isWebChatEnabled && isWebChatSpanishEnabled) {
            return 'es';
        } else {
            return false;
        }
    };

    const configLanguage = getConfigLanguage();

    
    let urlReplacements, capUrl, fullName, userId, activeModuleName, activeModuleId, externalHouseholdCaseId, impersonatedUserType, impersonatedUsername;
    const landingPage = encodeURIComponent(window.location.href);

    if(user) {
        capUrl = `${window.location.host}/cap/consumer/view/${user.encryptedUserName}`;
        fullName = impersonation ? `${impersonationDetails.firstName} ${impersonationDetails.lastName}` : `${user.firstName} ${user.lastName}`; 
        userId = impersonation ? impersonationDetails.userId : user.userId;
        activeModuleName = user.activeModuleName;
        activeModuleId = user.activeModuleId;
        externalHouseholdCaseId = impersonation ? impersonationDetails.externalHouseholdCaseId : user.externalHouseholdCaseId; 
        impersonatedUserType = impersonation ? user.role : null;
        impersonatedUsername = impersonation ? user.userName : null;
        const username = sessionStorage.getItem('householdEmail') || null;
        let ani = sessionStorage.getItem('householdPhone') || null;

        if (ani !== null) {
            ani = ani.slice(0,10).padStart(10, '0');
        }

        const userInfo = encodeURIComponent(
            JSON.stringify({
                'UserID': userId,
                'activeModuleName':  activeModuleName,
                'activeModuleID': activeModuleId,
                'fullName':  fullName,
                'externalHouseholdCaseID': externalHouseholdCaseId,
                'capUrl': capUrl,
                'isSessionImpersonated': impersonation,
                'impersonatedUserType': impersonatedUserType,
                'impersonatedUsername': impersonatedUsername,
                'ani': ani,
                'username': username                
            })
        );
    
        urlReplacements = {
            landingPage,
            language: configLanguage,
            userInfo 
        };

    } else {
        urlReplacements = {
            landingPage,
            language: configLanguage
        };
    }

    const url = links[path(configLanguage)] ? (links[path(configLanguage)]).processReplacements(urlReplacements) : path(configLanguage);

    var width = 390;
    var height = 700;
    var left = window.screen.availWidth - width - 15;
    var top = 155;

    var windowFeatures = `left=${left},top=${top},width=${width},height=${height}`;

    const handler = () => {
        window.open(
            url,
            'popup',
            windowFeatures
        );
    };
    
    return (
        <Fragment>
            {
                configLanguage ?

                    <li className={className}>
                        <a
                            href={'#'}
                            className={linkClassName}
                            id={`${name}_${index}`}
                            data-automation-id={name}
                            onClick={ () => handler() }
                            aria-label='live chat link'
                            data-testId='chat_link'

                        >
                            <FormattedMessage id = {text} />
                        </a>
                    </li>
                    :
                    null
            }    
        </Fragment>  
    );
};

export default ChatLink;
